import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowDown } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch, useAppSelector } from '../store';
import { setShowImportGames } from '../reducers/uiReducer';

export default function NoGames(): React.ReactNode {
  const dispatch = useAppDispatch();
  const { params } = useAppSelector((state) => state.paramsReducer);
  const gameIdForModal = useAppSelector((state) => state.uiReducer.gameIdForModal);
  const { username } = params;

  // Only a player searched (platform allowed): the games probably aren't here yet, so offer the import.
  // Any content filter means they're narrowing games that may exist, so leave them to adjust it.
  const onlyUserFilter =
    username != null &&
    username !== '' &&
    params.color == null &&
    params.result == null &&
    params.timeControl == null &&
    params.opening == null &&
    params.from == null &&
    params.to == null &&
    params.pgn == null &&
    !params.onlyStarred &&
    !params.favoriteMoves &&
    !params.hasComments &&
    !params.commentedByMe;

  // Open the import overlay at most once per searched handle, so dismissing it sticks. Not while a game
  // is deep-linked (…&gameId=…): an unviewable shared game leaves the list empty, and the game modal
  // shows its own message.
  const openedFor = useRef<string | null>(null);
  useEffect(() => {
    if (onlyUserFilter && gameIdForModal == null && openedFor.current !== username) {
      openedFor.current = username ?? null;
      dispatch(setShowImportGames(true));
    }
  }, [onlyUserFilter, username, gameIdForModal, dispatch]);

  return (
    <div id="no-games" className="cm-card p-3 mb-5">
      <h2>There are no games for your search</h2>
      {username != null ? (
        <>
          <p className="mb-3">
            We don't have any games for {username} yet. Bring them over and every mistake in them
            becomes something you can repair.
          </p>
          <button
            type="button"
            className="cm-import-prompt-link"
            onClick={() => dispatch(setShowImportGames(true))}
          >
            <FontAwesomeIcon icon={faCloudArrowDown} className="cm-import-prompt-icon" />
            Add Games
          </button>
        </>
      ) : (
        <p>Try removing or changing the filters </p>
      )}
    </div>
  );
}
